var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"my-btn",class:`${_vm.color}--text`,attrs:{"color":"primary","rounded":"","large":"","width":300}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.icon)?_c('v-icon',{staticClass:"primary--text",attrs:{"dark":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }